import axios from 'axios'

export const PostCowAssessment = (resolve, reject, dataObj, state) => {
    const postUrl = './api/SampleData/logActivity'
    const params = {
        "Name": "", //dataObj.Name,
        "Ranch": "", //dataObj.Ranch,
        "State": dataObj.State,
        "Address": "", //dataObj.Address,
        "Date": new Date(),
        "Comment": "", //dataObj.IPAddress,
        "Results": JSON.stringify(dataObj.AssessmentResults),
        "IndustryId": dataObj.IndustryId,
    }
    axios.post(postUrl, params).then(result => {
        resolve(result.data)
    }).catch((err => {
        reject(err)
    }))

}


// WEBPACK FOOTER //
// ./src/components/services/postCowAssessment.js